fx.ns("desktop.common.photoimport", class FacebookPanel extends fx.components.ScreenPopup {
    
	constructor(data)
	{
		super(data);

		this.showClose = true;

		this._assets = fx.get("assets");
		this._service = fx.service("FacebookService");
    }

	
	// ------------- RENDER -------------- //   

	create()
	{
		super.create();

		/*this.exitButton = new fx.components.IconButton( {icon: this._assets.ExitIcon, className : "exit"} );
		this.addChild(this.exitButton, {right:10, top:10, width:50, height:50});*/

		// auth panel
		let text = fx.text("Si rien ne ne se passe après avoir cliqué sur le bouton de connexion, cela signifie que votre navigateur bloque les popups. Il vous suffit d'autoriser votre navigateur à afficher les popups pour résoudre le problème.");
        this.auth = new shared.social.AuthComponent({social: "Facebook", icon: this._assets.facebookConnectBtn, width:162, height:46, service: this._service, text: text, logo: this._assets.facebookLogo});
		this.addChild(this.auth, {left: "center", top: "center", width: 350, height: 300});

		this.exitButton2 = new fx.components.Button({label: fx.text("Fermer"), className: 'button'});
		this.addChild(this.exitButton2, {bottom: 30, width : 200, left: "center"});
	}

	onReady()
	{
		super.onReady();

		//this.on("click",this.onBack, this.exitButton);
		this.on("click", this.onBack, this.exitButton2);
		this.on("error", this.onBack, this.auth);
		
		this._service.initSDK();
	}

	buildGallery()
	{
		// Header
		let facebookLogo = new fx.components.Image(this._assets.facebookLogo);
		let facebookLogoText = new fx.components.Text('Facebook');
		
		let logoWrapper = new fx.components.Box('icon-wrapper');
		logoWrapper.addChild(facebookLogo, {width:48, height:48});
		logoWrapper.addChild(facebookLogoText, {top:9, left:53});

		let boxHeader = new fx.components.Box('header');
		boxHeader.addChild(logoWrapper, {width:220, height:48});
		this.addChild(boxHeader, {top: 20, width: '100%', height: 48});

		// Selection
		this.selectAll = new fx.components.Text({text: fx.text('Tout sélectionner'), className: 'selectAll'});
		this.selectNone = new fx.components.Text({text: fx.text('Tout déselectionner'), className: 'selectNone'});

		let selectionAction = new fx.components.HBox('selection-action')
		selectionAction.addChild(this.selectAll);
		selectionAction.addChild(this.selectNone);
		
		let boxSelection = new fx.components.Box('selection');
		boxSelection.addChild(selectionAction, {right : 10, width: 300, height: 48});
		this.addChild(boxSelection, {top: 70, width: '100%', height: 40});
		
		// Container
		let boxContainer = new fx.components.Box('data');
		this.addChild(boxContainer, {top: 110, width: '100%', height: '100%'});

		// Albums
		let albumsGallery = new shared.social.SocialAlbumsGallery({data: this.data.facebook, service: this._service, assets: this._assets, width: 180, height: 140});

		let albums = new fx.components.Box('albums');
		albums.addChild(albumsGallery, {top: 0, width: "100%", height : "100%"});
		boxContainer.addChild(albums, {width: '205px', height: '100%'});
		
		// Photos
		this.uploadedPicturesLabel = new fx.components.Text({className: 'photos-header'});
		let photosGallery = new shared.social.SocialPhotosGallery({data: this.data.facebook, service: this._service, assets: this._assets, width: 130, height: 130});
		
		let photos = new fx.components.Box('photos');
		photos.addChild(this.uploadedPicturesLabel, {width: '100%', height: 28});
		photos.addChild(photosGallery, {width:"100%", height:"100%", top : 48});
		boxContainer.addChild(photos, {left: 210, width : "fill", height : "100%"});
		
        // Buttons
        this.exitButton2 = new fx.components.Button({label: fx.text("Fermer"), className: 'button'});
        this.okButton = new fx.components.Button({label: fx.text("Ajouter"), type : "filled", className: 'button', click: this.onOk.bind(this)});
		this.okButton.effect = "scale";
		this.okButton.visibleAtStart = false;
		
        let buttons = new fx.components.Box('button-container');
        buttons.addChild(this.exitButton2);
        buttons.addChild(this.okButton, {width : 220});           
		this.addChild(buttons, {bottom: 0, width: '100%', height: 80});

		this.on("click", this.onExit, this.exitButton2);
		this.on("click",this.onSelectAll, this.selectAll);
		this.on("click",this.onSelectNone, this.selectNone);
		this._updatePhotoCount();
	}

	// ------------- HANDLERS -------------- //

	onBack()
	{
		//this.data.facebook.event("selectphotos");
		//this.data.facebook.event("step-PhotoChoicesIA");
		this.close();
	}

	onExit()
	{
		//this.data.facebook.event("selectphotos");
		//this.data.facebook.event("step-PhotoChoicesIA");
		this.close();

		this.data.facebook.unSelectAllPhotos();
		this._updatePhotoCount();
	}

	onOk()
	{
		this._service.upload(this.data.facebook.selectedPhotos);

		this.close();
		this.data.event("facebook-photos-added", this.data.facebook.selectedPhotos);

		this.data.facebook.unSelectAllPhotos();
		this._updatePhotoCount();
	}

	_updatePhotoCount()
	{
		if (this.okButton == null) return;
		
		let number = this.data.facebook.selectedPhotos.length;		
		
		this.okButton.toggle( number > 0);
		this.okButton.css({display : (number > 0) ? "block" : "none"});
		
		this.okButton.label = fx.text("Ajouter $ photo$", [ number , (number > 1 ? "s" : "")]);
	}

	onSelectAll()
	{
		this.data.facebook.selectAllCurrentAlbumPhotos();

		this._updatePhotoCount();
	}
	
	onSelectNone()
	{
		this.data.facebook.unSelectAllCurrentAlbumPhotos();

		this._updatePhotoCount();
	}

	// ------------- METHODS -------------- //

	changeAlbumName()
	{
		let albumName = this.data.facebook.currentAlbum.name;

		if (this.uploadedPicturesLabel)
			this.uploadedPicturesLabel.text = albumName;
	}

	// ------------- EVENTS -------------- //

	onDataEvent(event)
	{
		if (event.type === "show-facebook-photos")
		{
			this.removeChild(this.exitButton2, true);
			this.auth.hide();

			this.buildGallery();
		}
    }

	onChildUpdated(action)
	{
		if (action.type === 'addItem')
		{
			if (this.uploadedPicturesLabel && this.uploadedPicturesLabel.text != this.data.facebook.currentAlbum.name)
				this.changeAlbumName();
		}
		
		if (action.type === 'update' && action.data.selected != 'undefined')
			this._updatePhotoCount();
		
		if (action.type === 'update' && action.data.isActive === true)
			this.changeAlbumName();
	}
	
});

